import { isRequired } from '../../utils.js';

var contentAction = (_ref => {
  let {
    action_type = isRequired('action_type'),
    action_value = isRequired('action_value')
  } = _ref;
  return () => ({
    action_type,
    /**
     * action_value can include a number (like a quiz_answer_id) along side string values such as
     * "add", "remove", etc. Because the input type can be number or string but the Data Registry
     * API will only accept strings for this field, the value will always be coerced to a string.
     * @type {String|Number}
     */
    action_value: action_value.toString()
  });
});

export default contentAction;
